import { FeedBackLevel } from '@chipinside/formbuilder'
import { Box, Typography } from '@mui/material'
import { useEffect } from 'react'

import { Dialog } from '#/components/Dialog'

type TitleProps = {
  title?: string
  subtitle?: string
  modal?: boolean
  level?: FeedBackLevel
}

export const FormbuilderTitle = ({ level, modal, subtitle, title }: TitleProps) => {
  if (!title) return null

  useEffect(() => {
    if (modal) {
      Dialog.update({
        header: {
          level: level,
          subtitle: subtitle,
          title: title,
        },
      } as any)
    }
  }, [])

  if (modal) return null

  return (
    <Box>
      <Typography variant="h5" color={level} sx={{ fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="subtitle1" color="secondary">
        {subtitle}
      </Typography>
    </Box>
  )
}
